import { useEffect, useRef, useState } from "react";
import { BannerPromoCode } from "schemas/dashboard";

export const useCountDown = () => {
  const [display, setDisplay] = useState<string | null>(null);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const createTimer = (
    bannerPromoCode: BannerPromoCode,
    newOverrideEndsAtUtc?: string,
  ) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    const endsAtUtc = newOverrideEndsAtUtc ?? bannerPromoCode?.endsAtUtc;
    if (!endsAtUtc) {
      setDisplay("");
      return;
    }

    const target = new Date(endsAtUtc).getTime();
    if (Number.isNaN(target)) {
      setDisplay("");
      return;
    }

    const tick = () => {
      const distance = target - Date.now();
      if (distance <= 0) {
        setDisplay("");
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        return;
      }
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      let text = "";
      if (days > 0) text += `${days}d `;
      if (hours > 0) text += `${hours}h `;
      if (minutes > 0) text += `${minutes}m `;
      text += `${seconds}s`;
      setDisplay(text);
    };

    tick();
    intervalRef.current = setInterval(tick, 1000);
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  return { display, createTimer };
};
